import ObtenerPlanes from '../functions/ObtenerPlanes';
import Planes from '../types/Planes';

export const CargarPlanes = async () => {
  //const plan = planesData.filter(item => item.id === idPlan);
  const planesData = await ObtenerPlanes("activos");
  return planesData.planes;
};

export const CargarPlan = async (idPlan: number) => {
  const planesData = await ObtenerPlanes("activos");
  const plan: Planes[] = planesData.planes.filter((item: Planes) => item.id === idPlan);
  return plan;
};

export default CargarPlanes;